export default __webpack_public_path__ + "static/media/setup-1.1d786353.png";